<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="checkSignForReceipt commonListStyles">
            <HeaderNav
                header-title="核对签收列表"
                left-icon-name="2"
                right-icon-name="5"
                :extr="{ leftCallBack: swiperright, rightCallBack: addFun, iconName: 'sm-icon-test' }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">汽运单编号：{{ item.ysd_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.state_name }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>供货单编号：{{ item.supply_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>供应商：{{ item.supplier_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_2@2x.png" alt="">
                                            <span>供货日期：{{ item.supply_date }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>采购类别：{{ item.supply_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_13@2x.png" alt="">
                                            <span>物料：{{ item.material_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>需求部门：{{ item.apply_dept_names }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_18@2x.png" alt="">
                                            <span>司机：{{ item.driver_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_9@2x.png" alt="">
                                            <span>联系电话：{{ item.driver_phone }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>到场时间：{{ item.into_time }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="item.status == 0">
                                            <van-button plain type="danger" @click="toDetail(item, 'edit')">
                                                编辑
                                            </van-button>
                                            <van-button plain type="danger" @click="deleteSignReceipt(item)">
                                                删除
                                            </van-button>
                                        </template>
                                        <template v-else>
                                            <van-button plain type="danger" @click="toDetail(item, 'view')">
                                                查看
                                            </van-button>
                                        </template>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'check-sign-for-receipt',
    mixins: [mixin_list],
    components: {
        HeaderNav,
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'check-sign-for-receipt');
        }
        next();
    },
    data() {
        return {
            tableCode: 'cg_ysd_hdqs',
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    computed: {},
    methods: {
        toDetail(item, type) {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/checkSignForReceiptDetail',
                query: {
                    id: item.id,
                    isView: type === 'view',
                } });
        },
        addFun() {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/checkSignForReceiptDetail',
                query: {
                    id: '',
                    isView: false,
                } });
        },
        deleteSignReceipt(item) {
            this.$dialog.confirm({
                message: '确认删除签收单？',
            }).then(async () => {
                const ids = [item.id];
                const res = await this.deleteRequest(ids);
                if (res) {
                    this.$toast.success('删除成功。');
                    this.onRefresh();
                }
            });
        },
        deleteRequest(ids) {
            return this.$axios.$post('/interfaceApi/procurement/ysd/deletes', ids);
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.checkSignForReceipt
    width 100%
    height 100%
    background #F0F0F0
    .content
        width 100%
        height calc(100% - 44rpx)
        >>>.van-search
            background #EAEAEA !important
            height 45rpx !important
        >>>.van-search__content
            background #fff !important
        .btn-con
            display flex
            position fixed
            width 100%
            height 59rpx
            bottom 0
            z-index 0
            background #fff
            padding 10rpx 25rpx
            .btn
                flex 1
                height 39rpx
                text-align center
                line-height 39rpx
                cursor pointer
            .submit-btn
                background #fcebec
                border 1px solid #f9cdcf
                color #ea4b49
                margin-right 18rpx
            .save-btn
                color #fff
                background: linear-gradient(to right, #EB6348, #e93543);
</style>
